import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Door Sensor Icon Style 02 - Sensor Door (Material Symbol)
 * Material sensor_door icon
 * - isOn = true (open): 紅色
 * - isOn = false (closed): 綠色
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:sensor_door
 */
export const Style02_SensorDoor: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-red-500' : 'text-green-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      sensor_door
    </span>
  );
};

export default Style02_SensorDoor;
